import {getUrlParams} from '../../../../../../common/getUrlParams';
import {
  TalkViewerData,
  ViewerInfo,
} from '../../../../../../graphql/generated/types';

export async function getTalkViewerContentUrl(
  productId: number,
  viewerInfoData: ViewerInfo
) {
  const {params} = getUrlParams(window.location.search);
  if (params.encryptedContentUrl) {
    return params.encryptedContentUrl;
  }

  if (window?.KPApp?.getEncryptedContentUrl?.()) {
    return `https://${window.KPApp.getEncryptedContentUrl()}`;
  }

  const talkViewerData = viewerInfoData.viewerData as TalkViewerData;
  if (!talkViewerData || !talkViewerData.talkDownloadData) {
    throw '톡뷰어 데이터가 없습니다.';
  }
  const {
    talkDownloadData: {host, path},
  } = talkViewerData;

  return `https://${host}${path}`;
}
